<fieldset class="fieldset bg-base-100 border-base-300 rounded-box w-full border p-4">
  <legend class="fieldset-legend"></legend>
  <label class="label">
    <input type="checkbox" [checked]="value" (change)="onInputChange($event)"/>
    {{ label }}
  </label>
</fieldset>
